import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CheckCircleOutline, PauseCircleOutline, HighlightOff, Remove } from "@mui/icons-material";
import { theme } from "../themes/theme";
import { StatusKey } from "../types/models/UserFitnessStatus";

export const getStatusDisplayname = (statusKey: StatusKey | null) => {
  switch (statusKey) {
    case "fit":
      return "Fit for Work";
    case "fit_restricted":
      return "Fit (with restrictions)";
    case "no_result":
      return "No result";
    case "not_active":
      return "Not on active duty";
    case "not_safety_critical":
      return "Not Performing";
    case "unfit":
      return "Unfit";
    default:
      break;
  }
};

export function getStatusColor(key: StatusKey | null) {
  switch (key) {
    case "fit":
      return "success";
    case "fit_restricted":
      return "warning";
    case "unfit":
      return "error";
    case "not_active":
      return "default";
    case "no_result":
      return "secondary";
    default:
      return "default";
  }
}

export function getStatusIcon(key: StatusKey | null) {
  switch (key) {
    case "fit":
      return <CheckCircleOutlineIcon />;
    case "fit_restricted":
      return <CheckCircleOutlineIcon />;
    case "no_result":
      return <ErrorOutlineIcon />;
    case "unfit":
      return <ErrorOutlineIcon />;
    case "not_active":
      return <InfoOutlinedIcon />;
    case "not_safety_critical":
      return <InfoOutlinedIcon />;
    default:
      break;
  }
}

export const getFitForWorkIcon = (statusKey: StatusKey, size: string) => {
  switch (statusKey) {
    case "fit":
      return (
        <CheckCircleOutline
          sx={{
            color: theme.table.pieChartCompletedColor,
            width: size,
            height: size,
          }}
        />
      );
    case "fit_restricted":
      return <CheckCircleOutline sx={{ color: "orange", width: size, height: size }} />;
    case "no_result":
      return <Remove sx={{ color: "lightgray", width: size, height: size }} />;
    case "not_active":
      return <PauseCircleOutline sx={{ color: "lightgray", width: size, height: size }} />;
    case "not_safety_critical":
      return <PauseCircleOutline sx={{ color: "lightgray", width: size, height: size }} />;
    case "unfit":
      return (
        <HighlightOff
          sx={{
            color: theme.table.pieChartHighlightedColor,
            width: size,
            height: size,
          }}
        />
      );
  }
};

export const getSortNumberForStatusKey = (statusKey: StatusKey) => {
  switch (statusKey) {
    case "fit":
      return 6;
    case "fit_restricted":
      return 5;
    case "no_result":
      return 1;
    case "not_active":
      return 2;
    case "not_safety_critical":
      return 3;
    case "unfit":
      return 4;
  }
};
